import React, { FC } from 'react';

import Checkbox from '@ui/CheckBox';
import FormFieldWrapper from '../Wrapper';
import { ICheckBoxFormField } from './interfaces';

const CheckBoxFormField: FC<ICheckBoxFormField> = ({
  name,
  children,
  required,
  ...props
}) => {
  return (
    <FormFieldWrapper
      name={name}
      required={required}
      render={({ value, ...fieldProps }) => (
        <Checkbox {...props} checked={value} {...fieldProps}>
          {children}
        </Checkbox>
      )}
    />
  );
};

export default CheckBoxFormField;
